export enum LegacyFit {
  Petite = 'petite',
  Regular = 'regular',
  Tall = 'tall',
}
